import { SUPPORTER_ID } from '@avanta/shared/constants/chat';
import { useConversationsStore } from '@avanta/shared/stores/chat/conversations';
import { useChatStore } from '@avanta/shared/stores/chat/index';
import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { ROUTES } from 'constants/routes';
import { useUserStore } from 'stores/user';

export const useChatInitializer = (): void => {
  const user = useUserStore(state => state.user);
  const initChat = useChatStore(state => state.initChat);
  const isInitialized = useChatStore(state => state.isInitialized);
  const loadConversations = useConversationsStore(state => state.loadConversations);
  const createConversation = useConversationsStore(state => state.createConversation);
  const { state } = useLocation();
  const lastCreatedTargetId = useRef<string | null>(null);
  const navigate = useNavigate();

  const userName =
    user?.firstName && user?.surname
      ? `${user.firstName} ${user.surname}`
      : user?.name || user?.nickname;

  useEffect(() => {
    if (!user) return;
    initChat(user.id, userName ?? undefined);
  }, [user, initChat, userName]);

  useEffect(() => {
    if (!isInitialized) return;
    loadConversations();
  }, [isInitialized, loadConversations]);

  useEffect(() => {
    if (!isInitialized) return;

    const targetId = state?.support && SUPPORTER_ID;

    if (targetId && lastCreatedTargetId.current !== targetId) {
      lastCreatedTargetId.current = targetId as string;
      void createConversation(targetId as string, () => navigate(ROUTES.HOME));
    }
  }, [isInitialized, state, createConversation, navigate]);
};
